/*
 * @Author: yunxiaodong
 * @Date: 2024-01-24 14:15:35
 * @LastEditTime: 2024-01-24 14:21:45
 * @LastEditors: your name
 * @Description:
 * @FilePath: \boe-srm-frame-frontend\src\plugins\install.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
/* eslint-disable */
import Vue from "vue";
import Element from "./element";
// import { uasInit } from "../util/uas.js";
// 注册组件
[...Element.components].forEach((i) => Vue.use(i));

// 注册指令服务
Element.serve.forEach((i) => Vue.use(i.directive));

// 注册挂载方法
Element.methods.forEach((i) => (Vue.prototype[`$${i.name}`] = i));
Vue.prototype.$http = window.axios;
